import { Table2 } from 'components'
import { useEffect, useState } from 'react'
import { Icon } from 'assets/index'
import Tooltip from 'react-tooltip'
import { Container, Status } from './style'

const columnsWidths = [175, 175, 140, 170, 170, 170, 170, 110]
const columnGap = 18
const itemsPerPage = 10

interface TableItem {
  value: { label: string; value: number }
  date: string
  pixType: string
  pixKey: string
  id: string
  bank: string
  status: { label: string; color: string; background: string }
  receipt: string
}

const TransactionTable = ({ data }: any) => {
  const [paginatedData, setPaginatedData] = useState<any[]>([]) // Itens rederizados por pagina da tabela
  const [pageTable, setPageTable] = useState<number>(1) // Pagina atual da tabela

  useEffect(() => {
    const start = (pageTable - 1) * itemsPerPage

    const dataWithCounter = data.map((item: any, index: number) => ({
      ...item,
      counter: index + 1, // Adciona um contador para cada item da tabela
    }))

    const newPaginatedData = dataWithCounter.slice(start, start + itemsPerPage)
    setPaginatedData(newPaginatedData) // Update the paginated data
  }, [pageTable, data])

  function tableRows(arr: any) {
    if (!arr) return []
    return arr?.map((item: TableItem, i: number) => {
      return [
        <div
          className="grid-item"
          data-testid={`value-${i}`}
          key={`value-${i}`}
          style={{ color: item.value.value > 0 ? '#00CD52' : '#D61212' }}
        >
          <p>{item.value.label}</p>
        </div>,
        <div className="grid-item" data-testid={`date-${i}`} key={`date-${i}`}>
          <p>{item.date}</p>
        </div>,
        <div
          className="grid-item"
          data-testid={`pix-type-${i}`}
          key={`pix-type-${i}`}
        >
          <p>{item.pixType}</p>
        </div>,
        <div
          className="grid-item"
          data-testid={`pix-key-${i}`}
          key={`pix-key-${i}`}
        >
          <p data-tip data-for={`pix-key-${i}-tooltip`}>
            {item.pixKey}
          </p>
          <Tooltip id={`pix-key-${i}-tooltip`} padding={'12px'}>
            <span>{item?.pixKey}</span>
          </Tooltip>
        </div>,
        <div className="grid-item" data-testid={`id-${i}`} key={`id-${i}`}>
          <p data-tip data-for={`id-${i}-tooltip`}>
            {item?.id}
          </p>
          <Tooltip id={`id-${i}-tooltip`} padding={'12px'}>
            {item?.id}
          </Tooltip>
        </div>,
        <div className="grid-item" data-testid={`bank-${i}`} key={`bank-${i}`}>
          <p data-tip data-for={`bank-${i}-tooltip`}>
            {item?.bank}
          </p>
          <Tooltip id={`bank-${i}-tooltip`} padding={'12px'}>
            {item?.bank}
          </Tooltip>
        </div>,
        <div className="status-container">
          <Status
            data-testid={`status-transfer-${i}`}
            color={item?.status?.color}
            background={item.status.background}
          >
            {item.status.label}
          </Status>
        </div>,
        <div className="receipt-container">
          <button
            id="receipt"
            type="button"
            className="grid-action-btn"
            disabled={!item.receipt}
          >
            <img
              src={Icon('document_check.svg')}
              className={`${!item.receipt && 'receipt-disabled'}`}
              alt="receipt"
              onClick={() =>
                item.receipt &&
                window.open(item.receipt, '_blank', 'noopener,noreferrer')
              }
              data-testid={`receipt-btn-${i}`}
            />
          </button>
        </div>,
      ]
    })
  }

  console.log('Page Data', tableRows(paginatedData))
  return (
    <Container data-testid="transaction-table">
      <Table2
        pageData={tableRows(paginatedData)}
        filterData={data}
        page={pageTable}
        setPage={setPageTable}
        header={[
          'VALOR TRANSFERIDO',
          'DATA E HORA',
          'TIPO DE CHAVE PIX',
          'CHAVE PIX',
          'ID DA TRANSAÇÃO',
          'BANCO',
          'STATUS',
          'COMPROVANTE',
        ]}
        columnsWidths={columnsWidths}
        columnGap={columnGap}
      />
    </Container>
  )
}

export default TransactionTable
